import { Link } from 'react-router';

import Image from '@components/Image';
import { Photo, Series } from '@types';
import { formatStartEndDates } from '@utils/formatters';
import { getStartEndDates } from '@utils/getters';
import { isSeriesCover } from '@utils/index';
import { IntlContext } from '@utils/useIntl';
import { useContext } from 'react';

interface LocationProps {
  location: Series;
  photosByLocation: Record<string, Photo[]>;
  zone: string;
}

const Location = ({ location, photosByLocation, zone }: LocationProps) => {
  const { locale, translateTrad } = useContext(IntlContext);

  const locationPhotos = photosByLocation[location.id];
  if (!locationPhotos.length) return null;

  const { start, end } = getStartEndDates(locationPhotos);

  const coverPhoto =
    locationPhotos.find(isSeriesCover(location)) || locationPhotos[0];

  return (
    <Link key={location.id} to={`/locations/${zone}/${location.id}`}>
      <Image
        photo={coverPhoto}
        label={translateTrad(location.name)}
        labelSub={formatStartEndDates(start, end, locale)}
      />
    </Link>
  );
};

export default Location;
